// extracted by mini-css-extract-plugin
export var container = "CalloutQuote-module--container--j0R4t";
export var ctas = "#226355";
export var grayBackground = "#f6f8fb";
export var quote = "CalloutQuote-module--quote--JFUSe";
export var source = "CalloutQuote-module--source--rMrnu";